import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { hasPermission, isAdminOrOwner } from '../utils/hasPermission';

PermissionGuard.propTypes = {
  permission: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  adminOrOwnerOnly: PropTypes.bool,
  children: PropTypes.node,
  fallback: PropTypes.node,
  redirectTo: PropTypes.string,
};

export default function PermissionGuard({
  permission = null,
  adminOrOwnerOnly = false,
  children = null,
  fallback = null,
  redirectTo = '',
}) {
  const { user, activeApp } = useSelector((state) => state.auth);

  let allowed = true;

  if (adminOrOwnerOnly) {
    allowed = isAdminOrOwner(user, activeApp);
  }

  if (allowed && permission) {
    allowed = hasPermission(user, permission);
  }

  if (!allowed) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }
    return fallback;
  }

  return <>{children}</>;
}
